import React, { FC, useMemo } from 'react'
import CircularProgress from '@pixel/core/CircularProgress'
import TextField from '@pixel/core/TextField'
import MenuItem from '@pixel/core/MenuItem'
import { styled } from '@pixel/core/styles'
import { Controller, useFormContext } from 'react-hook-form'
import { useMultipleLocalizedText } from '../../contexts/Localization/localizationHooks'
import useAutomationFormDataQuery, { DEFAULT_AUTOMATION_FORM_DATA } from '../hooks/useAutomationFormDataQuery'
import { renderLocalizedMenuItems } from '../../components/LocalizedMenuItem'
import LocalizedTypography from '../../components/LocalizedTypography'
import { LocalizedText } from '../../contexts/Localization/LocalizationTypes'

const TriggerSectionContainer = styled('div')({

})

const TriggerLoadingContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(1),
}))

interface TriggerSectionProps {

}

const TriggerSection: FC<TriggerSectionProps> = ({

}) => {
    const {
        AUTOMATION_FORM_TRIGGER,
        AUTOMATION_INPUT_NO_OPTIONS,
    } = useMultipleLocalizedText()

    const { control } = useFormContext()

    const {
        data,
        status,
    } = useAutomationFormDataQuery({
        onSuccess: () => {},
    })

    const { TRIGGERS } = data || DEFAULT_AUTOMATION_FORM_DATA

    const localizedTriggers = useMemo(() =>
        TRIGGERS.map(trigger => ({
            text: trigger.localeKey,
            value: trigger.triggerType,
        })),
    [TRIGGERS])

    if (status === 'loading') {
        return (
            <TriggerLoadingContainer>
                <CircularProgress size="32px" />
            </TriggerLoadingContainer>
        )
    }

    if (status === 'error') {
        return (
            <TriggerLoadingContainer>
                <LocalizedTypography color="error" text={LocalizedText.AUTOMATION_FORM_ERROR_TRIGGERS} />
            </TriggerLoadingContainer>
        )
    }

    return (
        <TriggerSectionContainer>
            <Controller
                control={control}
                name="triggerType"
                rules={{ required: true }}
                render={({ field, fieldState, }) => (
                    <TextField
                        id='automation-form-trigger-field'
                        select
                        required
                        label={AUTOMATION_FORM_TRIGGER}
                        value={field.value}
                        onBlur={field.onBlur}
                        onChange={field.onChange}
                        error={fieldState.invalid}
                        errorText={fieldState?.error?.message || ''}
                        fullWidth
                    >
                        { localizedTriggers.length === 0 && (
                            <MenuItem value="none" disabled>{AUTOMATION_INPUT_NO_OPTIONS}</MenuItem>
                        ) }
                        { localizedTriggers.map(renderLocalizedMenuItems) }
                    </TextField>
                )}
            />
        </TriggerSectionContainer>
    )
}

export default TriggerSection
